import { render, staticRenderFns } from "./ReleaseUnit.vue?vue&type=template&id=32093e24"
import script from "./ReleaseUnit.vue?vue&type=script&lang=js"
export * from "./ReleaseUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports